import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const ChargerStatusTableContainer = styled.div`
  grid-row: 2/4;
  grid-column: span 2;
  background-color: ${props => props.theme.colors.white};
  border-radius: ${pxToRem('20px')};
  box-shadow: ${props =>
    props.noShadow
      ? ''
      : `${pxToRem('2px')} ${pxToRem('1px')} ${pxToRem('0px')} -${pxToRem(
          '1px'
        )} rgb(0 0 0 / 7%)`};
  padding: ${pxToRem('15px')};
`;
export const ChargersContent = styled.div`
  display: grid;
  grid-column: repeat(5, 1fr);
  grid-template-columns: repeat(5, 1fr);
  padding: ${pxToRem('20px')};
  border-radius: ${props => (props.checked ? pxToRem('20px') : '')};

  :hover {
    box-shadow: ${pxToRem('0px')} ${pxToRem('2px')} #e4e3e3,
      -${pxToRem('1px')} -${pxToRem('2px')} #e4e3e3;
    border-radius: ${pxToRem('20px')};
  }

  background-color: ${props =>
    (props.checked ? props.theme.colors.lightGreen : '')};
`;
export const StatusHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  padding: ${pxToRem('20px')};
`;
export const HeaderTitle = styled.div`
  text-transform: uppercase;
`;
export const Chargers = styled.div`
  display: flex;
`;
export const UserID = styled.div`
  :hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
export const FwVersion = styled.div``;
export const City = styled.div``;
export const Status = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const StatusTitle = styled.div`
  &::before {
    content: '';
    height: ${pxToRem('8px')};
    width: ${pxToRem('8px')};
    border-radius: 50%;
    background-color: ${props =>
      (props.statusColor === 'Charging'
        ? props.theme.colors.statusGreen
        : props.statusColor === 'Stand-by'
        ? props.theme.colors.statusYellow
        : props.theme.colors.statusRed)};
    font-weight: bold;
    display: inline-block;
    margin-left: -1em;
    margin-right: ${pxToRem('10px')};
  }
`;
export const DeleteIcon = styled.div`
  color: ${props => props.theme.colors.fucsia};
`;

export const IconWrapper = styled.div`
  width: ${pxToRem('20px')};
  height: ${pxToRem('20px')};
  border-radius: 50%;
  background-color: ${props => props.theme.colors.mainGreen};
  margin-right: ${pxToRem('10px')};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
export const VoidIcon = styled.div`
  width: ${pxToRem('20px')};
  height: ${pxToRem('20px')};
  border-radius: 50%;
  border: ${pxToRem('2px')} solid ${props => props.theme.colors.mainGreen};
  margin-right: ${pxToRem('10px')};
  cursor: pointer;
`;
